import { useSyncExternalStore } from 'react';
import { fimStore, type FIMState } from '../data/fimStore';
import { gaugeStore } from '../data/gaugeStore';
import type { Gauge } from '../types/gauges';

export function useVisibleGauges(): Gauge[] {
  return useSyncExternalStore(gaugeStore.subscribe, gaugeStore.getSnapshot, gaugeStore.getSnapshot);
}

export function useFIM(): FIMState {
  return useSyncExternalStore(fimStore.subscribe, fimStore.getSnapshot, fimStore.getSnapshot);
}
